import * as RadixSelect from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';
import { cn } from '../../lib/cn';

export const Select = RadixSelect.Root;

export function SelectTrigger({ className, children, ...props }: RadixSelect.SelectTriggerProps) {
  return (
    <RadixSelect.Trigger
      className={cn(
        'flex h-10 w-full items-center justify-between rounded-xl border border-border bg-surface px-3 text-sm text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
      <RadixSelect.Icon>
        <ChevronDown size={16} className="text-ink-muted" />
      </RadixSelect.Icon>
    </RadixSelect.Trigger>
  );
}

export const SelectValue = RadixSelect.Value;

export function SelectContent({ children }: { children: React.ReactNode }) {
  return (
    <RadixSelect.Portal>
      <RadixSelect.Content className="z-50 overflow-hidden rounded-xl border border-border bg-surface-raised shadow-lg">
        <RadixSelect.Viewport className="p-1">{children}</RadixSelect.Viewport>
      </RadixSelect.Content>
    </RadixSelect.Portal>
  );
}

export function SelectItem({ className, children, ...props }: RadixSelect.SelectItemProps) {
  return (
    <RadixSelect.Item
      className={cn(
        'relative flex cursor-pointer select-none items-center rounded-lg px-8 py-2 text-sm text-ink outline-none data-[highlighted]:bg-brand-subtle data-[highlighted]:text-brand-hover',
        className,
      )}
      {...props}
    >
      <RadixSelect.ItemIndicator className="absolute left-2 inline-flex items-center">
        <Check size={14} />
      </RadixSelect.ItemIndicator>
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
    </RadixSelect.Item>
  );
}
